import { render, staticRenderFns } from "./WordsResizePanel.vue?vue&type=template&id=5638ebd2&scoped=true&"
import script from "./WordsResizePanel.vue?vue&type=script&lang=js&"
export * from "./WordsResizePanel.vue?vue&type=script&lang=js&"
import style0 from "./WordsResizePanel.vue?vue&type=style&index=0&id=5638ebd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5638ebd2",
  null
  
)

export default component.exports